<template>
    <div class="dashboard">
        
    </div>
</template>
    
<script>
    export default {
    name: 'List',
    components: {},
    data() {
        return {
        };
    },
    computed: {

    },
    methods: {

    },
    
    beforeMount() {
    },
    mounted() {   
    },
    created() {

    }
}
</script>
    